import { useEffect, useState } from "react";

import { LeanIcon } from "./LeanIcon";
import styles from "./LeanSearchField.module.scss";

export interface SearchFieldProps {
  value: string;
  onChange?: (value: string) => void;
  autoFocus?: boolean;
  placeholder?: string;
}

export const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, autoFocus, placeholder }) => {
  const [internalValue, setInternalValue] = useState<string>("");

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const handleCloseButton = () => {
    setInternalValue("");
    onChange!("");
  };

  return (
    <div className={styles.search}>
      <span className={styles.searchIcon}>
        <LeanIcon icon="Search" size="18px" />
      </span>
      <input
        className={styles.input}
        type="text"
        onChange={(e) => onChange?.(e.target.value)}
        value={internalValue}
        autoFocus={autoFocus}
        placeholder={placeholder}
      />
      {internalValue.length > 0 && (
        <span className={styles.clearIcon}>
          <LeanIcon icon="Cross" size="18px" onClick={handleCloseButton} />
        </span>
      )}
    </div>
  );
};
